import React from 'react';
import classnames from 'classnames';
import styles from "../../../admin/styles.module.scss";
import { MdDelete, MdEdit } from 'react-icons/md';
import { TooltipTop } from '@components/tooltips';
import { EyeIcon } from '@pages/workflow-analytics-page/assets/icons';
import { ModelRequestType } from './constant';

type ModelRequestsDataProps = {
    data: ModelRequestType[] | null;
    handleDelete: (item: ModelRequestType) => void;
    handleEdit: (item: ModelRequestType) => void;
    handleViewRequests: (item: ModelRequestType) => void;
};

const ModelRequestsLists: React.FC<ModelRequestsDataProps> = ({ data, handleDelete, handleEdit, handleViewRequests }) => {

    return (
        <div className={styles["assetList"]}>
            <ul className={classnames(styles['nifi_titles'])} style={{ maxHeight: '74vh' }}>
                {data?.map((item, index) => (
                    <li key={index}>
                        <div>
                            <div className={styles['key']}>Edge Data Pipeline Name</div>
                            <TooltipTop title={item.modelRequestName}>
                                <div className={styles['hierarchyName']}>{item.modelRequestName}</div>
                            </TooltipTop>
                        </div>
                        <div className={styles['divider']}></div>
                        <div>
                            <div className={styles['key']}>Server Name</div>
                            <div>{item.serverName}</div>
                        </div>
                        <div>
                            <div className={styles['key']}>Database Name</div>
                            <div>{item.dataBaseName}</div>
                        </div>
                        <div className={styles['divider']}></div>


                        <div className={styles.actions}>
                            <TooltipTop title="Edit Model Requests">
                                <button
                                    className={styles.actionButton}
                                    onClick={() => handleEdit(item)}
                                >
                                    <div className={styles.center}>

                                        <MdEdit size={"24px"} />
                                    </div>
                                </button>
                            </TooltipTop>
                            <TooltipTop title="View Requests">
                                <button
                                    className={styles.actionButton}
                                    onClick={() => handleViewRequests(item)}
                                >
                                    <div className={styles['center']}>
                                        <EyeIcon />
                                    </div>
                                </button>
                            </TooltipTop>
                            <TooltipTop title="Delete Model Requests">
                                <button
                                    className={styles.deleteButton}
                                    onClick={() => handleDelete(item)}
                                >
                                    <div className={styles.actionButton}>
                                        <MdDelete size={"24px"} />
                                    </div>
                                </button>
                            </TooltipTop>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ModelRequestsLists;
